export default __webpack_public_path__ + "static/media/FA2.342e262d.jpg";